module.exports = __webpack_public_path__ + "static/media/toyota-vest.589d3238.svg";